import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { utils, writeFile } from "xlsx";

export function formatCNPJ(cnpj) {
  if (!cnpj) return '';

  cnpj = cnpj.replace(/\D/g, '');

  return cnpj
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3/$4')
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/, '$1.$2.$3/$4-$5');
}


export function formatCEP(cep) {
  cep = cep.replace(/\D/g, '');

  return cep.replace(/(\d{5})(\d{3})/, '$1-$2');
}

export function formatarValorReal(valor) {
  if (!valor) {
    return "-";
  }

  return parseFloat(valor)
    .toFixed(2)
    .replace(".", ",")
    .replace(/(\d)(?=(\d{3})+,)/g, "$1.")
}

export function formatarCasasDecimais(valor) {
  if (valor == null || valor === '') return '0,00';

  if (typeof valor === 'number' && Number.isInteger(valor)) {
    return valor.toFixed(2).replace('.', ',');
  }

  const num = parseFloat(valor);

  if (!isNaN(num)) {
    return num.toFixed(2).replace('.', ',');
  }

  return '0,00';
}


export function corrigeValorTexto(value) {
  if (!value) return value;
  return value.replace(/,/g, '#').replace(/\./g, ',').replace(/#/g, '.');
}

export function formatarDataBR(dataInput) {
  if (!dataInput) {
    return "";
  }

  var ano = dataInput.substr(0, 4);
  var mes = dataInput.substr(4, 2);
  var dia = dataInput.substr(6, 2);

  return dia + "/" + mes + "/" + ano;
}

export function possuiDado(value) {  
  return value !== undefined && value !== null && value !== "" && value?.length !== 0;
}

export function dataToStringBR(dataString) {
  if (!dataString)
    return "-"
  var data = new Date(dataString);
  var dia = data.getDate();
  var mes = data.getMonth() + 1;
  var ano = data.getFullYear();
  var hora = data.getHours();
  var minutos = data.getMinutes();

  if (dia < 10) {
    dia = '0' + dia;
  }
  if (mes < 10) {
    mes = '0' + mes;
  }

  minutos = minutos.toString().padStart(2, '0');

  return dia + '/' + mes + '/' + ano + ' ' + hora + ':' + minutos;
}

export function dataToStringSemHrBR(dataString) {
  var data = new Date(dataString);
  var dia = data.getDate();
  var mes = data.getMonth() + 1;
  var ano = data.getFullYear();

  if (dia < 10) {
    dia = '0' + dia;
  }
  if (mes < 10) {
    mes = '0' + mes;
  }

  return dia + '/' + mes + '/' + ano;
}

export function dateFilter(removeDay = 0) {
  var date = new Date();
  date.setDate(date.getDate() - removeDay);
  return date.toISOString().substr(0, 10);
}

export function currentDate() {
  const currentDate = new Date();
  const day = String(currentDate.getDate()).padStart(2, '0');
  const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = currentDate.getFullYear();
  const hours = String(currentDate.getHours()).padStart(2, '0');
  const minutes = String(currentDate.getMinutes()).padStart(2, '0');
  const seconds = String(currentDate.getSeconds()).padStart(2, '0');

  return `${day}${month}${year}${hours}${minutes}${seconds}`;
}

export function downloadPDF(base64String, nomeArquivo) {
  const byteCharacters = atob(base64String);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: "application/pdf" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = `${nomeArquivo}_${currentDate()}.pdf`;
  link.click();

  // Cleanup
  URL.revokeObjectURL(url);
}

export const gerarPDFBlob = async (idElemento) => {
  const elemento = document.getElementById(idElemento);
  if (!elemento) return null;

  const elementosEscondidos = document.querySelectorAll(".collapse");
  elementosEscondidos.forEach(el => el.classList.remove("collapse"));

  await new Promise(resolve => setTimeout(resolve, 300));

  const canvas = await html2canvas(elemento, { scale: 1.5 });
  const imagemBase64 = canvas.toDataURL("image/png");

  elementosEscondidos.forEach(el => el.classList.add("collapse"));
  const pdf = new jsPDF("p", "mm", "a4");
  const imgWidth = 210;
  const pageHeight = 297;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  let yPosition = 0;

  while (yPosition < imgHeight) {
    if (yPosition > 0) pdf.addPage();
    pdf.addImage(imagemBase64, "PNG", 0, -yPosition, imgWidth, imgHeight, undefined, "FAST");
    yPosition += pageHeight;
  }

  return pdf.output("blob");
};

export const gerarHTMLParaPDF = (idElemento) => {
  const elemento = document.getElementById(idElemento);
  if (!elemento) return null;

  // Remove classes de collapse para garantir que tudo seja renderizado
  const elementosEscondidos = document.querySelectorAll(".collapse");
  elementosEscondidos.forEach(el => el.classList.remove("collapse"));

  // Clonar o elemento para evitar alterações visuais na página
  const clone = elemento.cloneNode(true);

  // Restaurar as classes removidas após a clonagem
  elementosEscondidos.forEach(el => el.classList.add("collapse"));

  // Copiar estilos inline para manter a formatação
  const styles = [...document.styleSheets]
    .map(sheet => {
      try {
        return [...sheet.cssRules].map(rule => rule.cssText).join(" ");
      } catch (error) {
        return "";
      }
    })
    .join(" ");

  // Formatar o HTML final com estilos embutidos
  const htmlFormatado = `
    <html>
      <head>
        <style>${styles}</style>
      </head>
      <body>
        ${clone.outerHTML}
      </body>
    </html>
  `;

  return htmlFormatado;
};


export const exportToExcel = (data, name) => {
  const ws = utils.json_to_sheet(data);
  
  const wb = utils.book_new();
  utils.book_append_sheet(wb, ws, name);
  
  writeFile(wb, `${name}.xlsx`);
};